import { http, formatURI } from './public'

export const memberServiceApi = {
    findPageList(params, page){
        let url = formatURI('/services/member/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    updateLevelByHand(params){
        return http.fetchPost('/services/member/updateLevelByHand', params)
    },
    updateFlag(params){
        return http.fetchPost('/services/member/updateFlag', params)
    },
    updateMember(params){
        return http.fetchPost('/services/member/updateMember', params)
    },
    findInviteTeamList(params){
        return http.fetchPost('/services/member/findInviteTeamList', params)
    },
    findUnderTeamList(params){
        return http.fetchPost('/services/member/findUnderTeamList', params)
    }
}

export const sysConfigApi = {
    findPageList(params, page) {
        let url = formatURI('/services/sys/config/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findList(params){
        return http.fetchPost('/services/sys/config/findList', params)
    },
    findById(params) {
        return http.fetchPost('/services/sys/config/findById', params)
    },
    update(params) {
        return http.fetchPost('/services/sys/config/update', params)
    },
    delete(params) {
        return http.fetchPost('/services/sys/config/delete', params)
    },
    findByParentCode(params) {
        return http.fetchPost('/services/sys/config/findByParentCode', params)
    },
    findOne(params) {
        return http.fetchPost('/services/sys/config/findOne', params)
    },
}

export const sysDictApi = {
    findPageList(params, page) {
        let url = formatURI('/services/sys/dict/findPageList/page/{0}/{1}', page.pageSize, page.pageNum)
        return http.fetchPost(url, params)
    },
    findList(params){
        return http.fetchPost('/services/sys/dict/findList', params)
    },
    update(params) {
        return http.fetchPost('/services/sys/dict/update', params)
    },
    delete(params) {
        return http.fetchPost('/services/sys/dict/delete', params)
    }
}